module.exports = __webpack_public_path__ + "img/border_gemstone.3ac3f81e.svg";